// export this package's api
import Cascader from './Cascader';
export default Cascader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.0.13.1@rc-cascader/es/index.js
// module id = 653
// module chunks = 1